import { useState, useEffect, useCallback } from 'react';

export const useResendTimer = (email: string) => {
  const STORAGE_KEY = `resend_confirmation_timer_${email}`;
  const RATE_LIMIT_SECONDS = 60;

  const [secondsRemaining, setSecondsRemaining] = useState(0);
  const [isDisabled, setIsDisabled] = useState(false);

  // Initialize from localStorage on mount
  useEffect(() => {
    const storedTimestamp = localStorage.getItem(STORAGE_KEY);
    if (storedTimestamp) {
      const elapsed = Math.floor((Date.now() - parseInt(storedTimestamp)) / 1000);
      const remaining = RATE_LIMIT_SECONDS - elapsed;
      if (remaining > 0) {
        setSecondsRemaining(remaining);
        setIsDisabled(true);
      } else {
        localStorage.removeItem(STORAGE_KEY);
      }
    }
  }, [email, STORAGE_KEY]);

  // Countdown interval
  useEffect(() => {
    if (secondsRemaining <= 0) {
      setIsDisabled(false);
      localStorage.removeItem(STORAGE_KEY);
      return;
    }

    const interval = setInterval(() => {
      setSecondsRemaining((prev) => {
        if (prev <= 1) {
          setIsDisabled(false);
          localStorage.removeItem(STORAGE_KEY);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [secondsRemaining, STORAGE_KEY]);

  const startTimer = useCallback(() => {
    localStorage.setItem(STORAGE_KEY, Date.now().toString());
    setSecondsRemaining(RATE_LIMIT_SECONDS);
    setIsDisabled(true);
  }, [STORAGE_KEY]);

  const buttonText = secondsRemaining > 0
    ? `Resend Confirmation Email (${secondsRemaining}s)`
    : 'Resend Confirmation Email';

  return { isDisabled, startTimer, buttonText };
};

